import React from "react";
import IncomeOrderView from "./IncomeOrderView";
import useIncomeOrder from "./useIncomeOrder";

function IncomeOrder() {
  return <IncomeOrderView {...useIncomeOrder()} />;
}

export default IncomeOrder;
